import { Chip, TextField, TextFieldProps } from '@mui/material'
import I18n from 'i18n-js'

import MenuItemWithCheckbox from '@src/lib/MenuItemWithCheckbox'
export interface SelectOptions {
  value: string
  label: string
  customTextColor?: string
  customColor?: string
}

interface MultipleSelectChipProps
  extends Omit<
    TextFieldProps,
    'value' | 'onChange' | 'size' | 'classes' | 'select' | 'SelectProps'
  > {
  options: SelectOptions[]
  onChange: (event: React.ChangeEvent<{ value: string[] }>) => void
  value: string[]
  size?: 'small' | 'medium'
  classes?: Record<'textField' | 'chipsWrapper', string>
  shouldShowAll?: boolean
}

const MultipleSelectChip: React.FC<
  React.PropsWithChildren<MultipleSelectChipProps>
> = ({
  value,
  label = '',
  size = 'small',
  onChange,
  options,
  classes,
  shouldShowAll,
  ...rest
}) => {
  if (shouldShowAll) {
    options = [
      {
        label: I18n.t('filters.all'),
        value: 'all',
      },
      ...options,
    ]
  }
  return (
    <TextField
      {...rest}
      className={classes?.textField}
      value={value}
      onChange={(e) => {
        const eventCasted = e as unknown as React.ChangeEvent<{
          value: string[]
        }>
        const allIndex = eventCasted.target.value.indexOf('all')
        const didClickAll = allIndex === eventCasted.target.value.length - 1

        if (didClickAll) {
          onChange({
            ...eventCasted,
            target: {
              ...eventCasted.target,
              value: ['all'],
            },
          })
        } else {
          onChange({
            ...eventCasted,
            target: {
              ...eventCasted.target,
              value: eventCasted.target.value.filter((x) => x !== 'all'),
            },
          })
        }
      }}
      label={label}
      size={size}
      SelectProps={{
        multiple: true,
        renderValue: (selected) => (
          <div className={classes?.chipsWrapper}>
            {(selected as string[]).map((value) => {
              const option = options.find((el) => el?.value === value)
              return (
                <Chip
                  size={size}
                  key={value}
                  label={option?.label}
                  style={{
                    backgroundColor: option?.customColor,
                    color: option?.customTextColor,
                  }}
                />
              )
            })}
          </div>
        ),
        MenuProps: {
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'center',
          },
        },
      }}
      select
    >
      {options.map((option) => (
        <MenuItemWithCheckbox key={option?.value} value={option?.value}>
          <Chip
            size={size}
            key={option.value}
            label={option.label}
            style={{
              backgroundColor: option?.customColor,
              color: option?.customTextColor,
              cursor: 'pointer',
            }}
          />
        </MenuItemWithCheckbox>
      ))}
    </TextField>
  )
}

export default MultipleSelectChip
